import { useStore } from '@store/index';

import { addOrgPrefix } from '@/utils/routes';

export const useOrganizationSwitcher = () => {
  const { selectedOrganizationId } = useStore();

  const switchToOrganization = (newOrgId: string) => {
    // Don't switch if it's the same organization
    if (newOrgId === selectedOrganizationId) {
      return;
    }
    try {
      // Navigate to the new organization's root path
      window.location.href = `${window.location.origin}/${addOrgPrefix(newOrgId)}`;
    } catch (error) {
      console.error('Failed to switch organization:', error);
    }
  };

  return {
    switchToOrganization,
  };
};
